import { Box, Flex } from '@/ui';
import { ACCENT, BAR } from './constants';

// The split planner week (PlannerWeek): five weekday boxes on top, two wide
// weekend boxes below — mirroring the template's 5-column / 2-column grid.
export const WeekSplitThumbnail = () => (
  <Flex direction="column" gap="3px" h="full" w="full">
    <Flex flex={3} gap="3px">
      {Array.from({ length: 5 }).map((_, i) => (
        <Box
          bg={i === 2 ? ACCENT : BAR}
          borderRadius="2px"
          flex={1}
          key={i}
          opacity={i === 2 ? 0.55 : 0.35}
        />
      ))}
    </Flex>
    <Flex flex={1} gap="3px">
      {[0, 1].map((i) => (
        <Box bg={BAR} borderRadius="2px" flex={1} key={i} opacity={0.35} />
      ))}
    </Flex>
  </Flex>
);
